import { render } from "./additionalTest.vue?vue&type=template&id=6c8f2589"
import script from "./additionalTest.vue?vue&type=script&lang=js"
export * from "./additionalTest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__